/**
 * Copyright (C) Siemens AG 1996-2026 ALL RIGHTS RESERVED.
 *
 * Build-time authentication provider selection
 *
 * Normalizes the build-time identity-provider setting so that existing builds
 * keep Auth0 unless Keycloak is explicitly selected.
 */

/** Internal provider identifiers used by the web application bundle. */
export type AuthenticationProviderType = 'auth0' | 'keycloak';

/**
 * Resolves a raw build-time provider value to a supported provider type.
 *
 * Only the exact, case-insensitive `KEYCLOAK` value selects Keycloak. All
 * missing, empty, or invalid values intentionally fall back to Auth0 to
 * preserve the existing application behavior.
 *
 * @param value - The raw `BP_AUTH_PROVIDER` build-time environment value.
 * @returns The selected supported authentication provider type.
 */
export function getAuthenticationProviderType(
  value: string | undefined,
): AuthenticationProviderType {
  return value?.trim().toLowerCase() === 'keycloak' ? 'keycloak' : 'auth0';
}
